import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { vehiclesSelector } from '../../../../../../../vehicles/selectors/vehicles';

import Client from './Client';

const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector
});

export default connect(mapStateToProps)(Client);